import React, {Component} from 'react'
import Hammer from 'react-hammerjs'
import _ from 'lodash'

class DisplayWall extends Component {
  constructor(props) {
    super(props)
    this.state = {
      touchAction: 'compute',
      translateX: 0,
      translateY: 0,
      scale: 1.0,
      pinchScale: 1.0,
      pinchCenter: {x: 0, y: 0},
      deltaX: 0,
      deltaY: 0,
      addedHoldWidth: 0,
      addedHoldHeight: 0,
    }
    this.setHammerRef = this.setHammerRef.bind(this)
  }
  // componentDidMount(){
  //   window.addEventListener('contextmenu', function (e) { // Not compatible with IE < 9
  //       e.preventDefault();
  //   }, false);
  // }
  // componentWillUnmount(){
  //   window.removeEventListener('contextmenu', function (e) { // Not compatible with IE < 9
  //       e.preventDefault();
  //   }, false);
  // }
  componentWillReceiveProps(nextProps) {
    // this.setState({
    //   touchAction: 'compute',
    //   translateX: 0,
    //   translateY: 0,
    //   scale:  1.0,
    //   pinchScale: 1.0,
    //   pinchCenter: {x: 0, y: 0},
    //   deltaX: 0,
    //   deltaY: 0,
    //   addedHoldWidth: 0,
    //   addedHoldHeight: 0,
    // })
  }
  handleTap = e => {
    console.info('TAP')
  }
  handlePress = e => {
    console.info('press')
    this.setState({
      resizingHold: true,
    })
  }
  handlePressUp = e => {
    console.info('pressup')
    this.setState({
      resizingHold: false,
    })
  }
  handlePan = e => {
    let scale = this.state.scale
    let deltaX = e.deltaX / scale
    let deltaY = e.deltaY / scale
    if (this.state.resizingHold) {
      this.setState({
        addedHoldWidth: deltaX,
        addedHoldHeight: -deltaY,
      })
    } else {
      this.setState({
        deltaX: deltaX,
        deltaY: deltaY,
      })
    }
  }

  handlePanStart = e => {
    this.disableImgTouches = true
  }
  handlePanEnd = e => {
    let scale = this.state.scale
    let eScaled = _.cloneDeep(e)
    eScaled.deltaX = e.deltaX / scale
    eScaled.deltaY = e.deltaY / scale
    this.props.updateNewHold(eScaled, {resizingHold: this.state.resizingHold})
    this.disableImgTouches = false
    this.setState({
      deltaX: 0,
      deltaY: 0,
      resizingHold: false,
      addedHoldWidth: 0,
      addedHoldHeight: 0,
    })
  }

  handleImgPan = e => {
    if (this.disableImgTouches) {
      return
    }
    let tX = this.state.translateX + 20 * e.velocityX
    let tY = this.state.translateY + 20 * e.velocityY
    let scale = this.state.scale
    let clientWidth = this.props.clientWidth
    let clientHeight = this.props.clientHeight
    let width = scale * clientWidth
    let height = scale * clientHeight
    let overFlowX = width / 2 - clientWidth / 2
    let overFlowY = height / 2 - clientHeight / 2

    if (tX > overFlowX) {
      tX = overFlowX
    } else if (tX < -overFlowX) {
      tX = -overFlowX
    }
    if (tY > overFlowY) {
      let currentScroll = document.documentElement.scrollTop
      window.scrollTo(0, currentScroll - Math.round(20 * e.velocityY))
      tY = overFlowY
    } else if (tY < -overFlowY) {
      let currentScroll = document.documentElement.scrollTop
      window.scrollTo(0, currentScroll - Math.round(20 * e.velocityY))
      tY = -overFlowY
    }
    this.setState({
      translateX: tX,
      translateY: tY,
    })
  }

  handleImgPinch = e => {
    if (this.disableImgTouches) {
      return
    }
    if (this.state.scale * e.scale > 1) {
      this.setState({
        pinchScale: e.scale,
        pinchCenter: e.center,
      })
    }
  }

  handleImgPinchStart = e => {}
  handleImgPinchEnd = e => {
    let pinchScale = this.state.pinchScale
    let scale = this.state.scale
    let pinchX = this.props.clientWidth / 2 - this.state.pinchCenter.x
    let pinchY = this.props.clientHeight / 2 - this.state.pinchCenter.y
    let tX = this.state.translateX
    let tY = this.state.translateY
    this.setState({
      pinchScale: 1.0,
      scale: scale * pinchScale,
      pinchCenter: {x: 0, y: 0},
      translateX: pinchScale * tX + pinchScale * pinchX - pinchX,
      translateY: pinchScale * tY + pinchScale * pinchY - pinchY,
    })
  }

  handleImgTap = e => {
    if (this.disableImgTouches) {
      return
    }
    this.setState({
      pinchScale: 1.0,
      pinchCenter: {x: 0, y: 0},
      scale: 1.0,
      translateX: 0,
      translateY: 0,
    })
  }

  handleImgPress = e => {
    if (!this.props.isAddingHold && this.props.isEditing) {
      let eScaled = _.cloneDeep(e)
      let rectP = e.target.parentNode.getBoundingClientRect()
      let scale = this.state.scale
      let xp = e.center.x
      let yp = e.center.y
      let tx = this.state.translateX
      let ty = this.state.translateY
      let w = this.props.clientWidth
      let h = this.props.clientHeight
      let top = rectP.top
      let left = rectP.left
      let x = (xp - w / 2 - left - tx) / scale + w / 2
      let y = (yp - h / 2 - top - ty) / scale + h / 2
      eScaled.center.x = x
      eScaled.center.y = y
      this.props.addHold(eScaled)
    }
  }

  handlePinch = e => {
    // console.info(e.additionalEvent)
    // console.info(e.deltaY)
    // console.info(e)
    // console.info(e.rotation)
    // this.props.updateNewHold(e)
  }

  handleTouchStart = e => {
    console.info('touchstart')
  }
  handleTouchEnd = e => {
    console.info('touchend')
  }
  handleContextMenu = e => {
    console.info('Context Menu')
  }
  setHammerRef(ref) {
    if (!ref) {
      return
    }
    this.hammerRef = ref
    window.hr = ref
  }

  renderSVG = options => {
    let {
      holds,
      scaledHeight,
      scale,
      handleHoldClick,
      selectedFillOpacity,
      unselectedFillOpacity,
      unselectedStrokeOpacity,
    } = this.props
    if (!selectedFillOpacity) {
      selectedFillOpacity = 0.0
    }
    if (!unselectedFillOpacity) {
      unselectedFillOpacity = 0.0
    }
    if (!unselectedStrokeOpacity) {
      unselectedStrokeOpacity = 0.0
    }
    let fillOpacity
    return (
      <svg
        width="100%"
        height={scaledHeight}
        onContextMenu={this.handlContextMenu}
        onClick={this.handlContextMenu}
        ref={this.setHammerRef}
        id="overlay-svg"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: this.props.clientWidth + 'px',
          height: this.props.clientHeight + 'px',
          transform: options.transform,
        }}>
        {holds.map((hold, index) => {
          let xmin =
            hold.xmin * scale +
            this.state.deltaX -
            this.state.addedHoldWidth / 2.0
          let ymin =
            hold.ymin * scale +
            this.state.deltaY -
            this.state.addedHoldHeight / 2.0
          let width =
            (hold.xmax - hold.xmin) * scale + this.state.addedHoldWidth
          let height =
            (hold.ymax - hold.ymin) * scale + this.state.addedHoldHeight
          let color
          let fillColor = this.state.resizingHold ? 'red' : 'blue'
          fillOpacity = hold.selected
            ? selectedFillOpacity
            : unselectedFillOpacity
          if (hold.startHold) {
            color = 'blue'
          } else if (hold.endHold) {
            color = 'red'
          } else if (hold.selected) {
            color = '#039921'
          } else {
            color = 'pink'
          }
          let res
          if (this.props.isAddingHold) {
            res = (
              <Hammer
                key={index}
                onTap={this.handleTap}
                direction="DIRECTION_ALL"
                onPan={this.handlePan}
                onPanStart={this.handlePanStart}
                onPanEnd={this.handlePanEnd}
                onPress={this.handlePress}
                onPressUp={this.handlePressUp}>
                <rect
                  key={index}
                  x={xmin}
                  y={ymin}
                  width={width}
                  height={height}
                  onClick={() => {
                    handleHoldClick && handleHoldClick(hold, index)
                  }}
                  style={{
                    fill: fillColor,
                    strokeWidth: '0.5%',
                    stroke: color,
                    fillOpacity: fillOpacity,
                    strokeOpacity:
                      (hold.selected && 1.0) || unselectedStrokeOpacity,
                  }}
                />
              </Hammer>
            )
          } else {
            res = (
              <rect
                key={index}
                x={xmin}
                y={ymin}
                width={width}
                height={height}
                onClick={() => {
                  handleHoldClick && handleHoldClick(hold, index)
                }}
                style={{
                  fill: 'blue',
                  strokeWidth: '0.5%',
                  stroke: color,
                  fillOpacity: fillOpacity,
                  strokeOpacity:
                    (hold.selected && 1.0) || unselectedStrokeOpacity,
                }}
              />
            )
          }
          return res
        })}
        Sorry, your browser does not support inline SVG.
      </svg>
    )
  }

  render() {
    let {wallUrl, setImageRef} = this.props
    let tX = this.state.translateX
    let tY = this.state.translateY
    let translate = `translate(${tX}px, ${tY}px)`
    let scale = `scale(${this.state.scale}, ${this.state.scale})`
    let transform = translate + ' ' + scale

    let pinchX = this.props.clientWidth / 2 - this.state.pinchCenter.x
    let pinchY = this.props.clientHeight / 2 - this.state.pinchCenter.y
    let pinchTranslate = `translate(${pinchX}px, ${pinchY}px)`
    let pinchUnTranslate = `translate(${-pinchX}px, ${-pinchY}px)`
    let pinchScale = `scale(${this.state.pinchScale}, ${this.state.pinchScale})`
    let pinchTransform =
      pinchUnTranslate + ' ' + pinchScale + ' ' + pinchTranslate
    transform = pinchTransform + ' ' + transform

    let wrapperHeight = this.props.clientHeight

    return (
      <Hammer
        onTap={this.handleImgTap}
        direction="DIRECTION_ALL"
        onPan={this.handleImgPan}
        onPinch={this.handleImgPinch}
        onPinchStart={this.handleImgPinchStart}
        onPinchEnd={this.handleImgPinchEnd}
        onPress={this.handleImgPress}
        options={{
          recognizers: {
            pinch: {enable: true},
            tap: {
              taps: 2,
            },
          },
        }}>
        <div
          className="edit-img-wrapper"
          style={{
            width: '100%',
            height: wrapperHeight + 'px',
            position: 'relative',
            left: '0px',
            top: '0px',
          }}>
          <img
            src={wallUrl}
            alt="wall"
            ref={imageRef => {
              setImageRef(imageRef)
            }}
            style={{
              position: 'absolute',
              width: this.props.clientWidth + 'px',
              height: this.props.clientHeight + 'px',
              maxWidth: 'unset',
              transform: transform,
            }}
          />
          {this.renderSVG({transform: transform})}
        </div>
      </Hammer>
    )
  }
}

export default DisplayWall



// WEBPACK FOOTER //
// ./src/components/walls/DisplayWallEdit.jsx